import { API_BASE_URL } from "../../config/apiConfig";
import type { LoginResponse } from "../../models/auth/AuthModels";

export const loginApi = async (
  email: string,
  password: string
): Promise<LoginResponse> => {

  const response = await fetch(`${API_BASE_URL}/Accounts/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      email,
      password
    })
  });

  const data: LoginResponse = await response.json();
  return data;
};

export const refreshTokenApi = async (
  token: string,
  refreshToken: string
): Promise<LoginResponse> => {

  const response = await fetch(`${API_BASE_URL}/Accounts/refresh`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      token: token,
      refreshToken: refreshToken
    })
  });

  const data: LoginResponse = await response.json();
  return data;
};